module.exports = __webpack_public_path__ + "img/app/home/img/icon-arrow-lf-normal.48d938417e2aed32cd188929de652daf.png";